<template>
  <a-layout-content
    :style="{ padding: '0 0px', marginTop: '0px' ,background: '#eceff3' ,minHeight:'10px' }">


    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol" @submit="handleSubmit">
      <!-- 发品固定输入 -->
      <div :style="{ background: '#fff', padding: '24px', minHeight: '220px' }">
        <a-space direction="horizontal" align="start" :size="1000">
          <template>
            <div>
              <a-button type="primary" @click="showModal">
                {{$t('message.views.productPublishView.batchPublish')}}
              </a-button>
              <a-modal v-model="draw" :title="$t('message.views.productPublishView.batchPublish')" @ok="handleOk"
                       @cancel="closeModel">
                <a href="https://dchain-crossborder.oss-ap-southeast-1.aliyuncs.com/product/publishTemplate.xlsx"
                   download="publishTemplate.xlsx">{{$t('message.views.productPublishView.clickDownloadPublishTemplate')}}</a>
                <import-alert ref="importAlert"></import-alert>

                <p></p>
                <a-select style="width: 300px" :placeholder="$t('message.views.productPublishView.pleaseChooseTheShop')"
                          @change="onBatchSellerChange"
                          v-decorator="['site', { rules: [{ required: true, message: 'Please select the Shop'}] }]">
                  <a-select-option v-for="shop in this.shopSelectValues" :key="shop.key">
                    {{ shop.name }}
                  </a-select-option>
                </a-select>
                <p></p>
                <a-cascader style="width:300px" :options="options" :showSearch="true"
                            :placeholder="$t('message.views.productPublishView.pleaseSelectTheCategory')"
                            @change="onCategoryChange"
                            v-decorator="['categoryId', { rules: [{ required: true, message: 'Please select the Category' }] }]"/>
                <p></p>
                <template>
                  <a-upload
                    name="file"
                    accept=".xlsx"
                    :maxCount=1
                    :multiple="false"
                    :showUploadList="true"
                    :headers="headers"
                    :withCredentials="true"
                    :beforeUpload="beforeUpload"
                    @change="handleImportChange"
                  >
                    <a-button>
                      <a-icon type="upload"/>
                      {{$t('message.views.productPublishView.import')}}
                    </a-button>
                  </a-upload>
                </template>

              </a-modal>
              <a-modal v-model="publishModelFailedShow" :title="$t('message.views.productPublishView.batchPublish')"
                       @ok="handlePublishModelOk"
                       @cancel="closePublishModel">
                <template>
                  <a-alert message="Failed" type="error">
                  </a-alert>
                  <div style="padding: 8px">
                    <p slot="description" style="font-size: 6px">
                      <span style="color: black;font-size: 3px">{{this.productPublishResult.errorMsg}}</span>
                    </p>
                  </div>
                </template>
              </a-modal>
              <a-modal v-model="publishModelShow" :title="$t('message.views.productPublishView.batchPublish')"
                       @ok="handlePublishModelOk"
                       @cancel="closePublishModel">
                <template>
                  <a-alert message="Success" type="success">
                  </a-alert>
                  <div style="padding: 8px">
                    <p slot="skuCode" style="font-size: 6px">
                      <span style="color: black;font-size: 3px">PlatformSku:  </span>{{this.productPublishResult.data.cbPublishSkus[0].skuCode}}
                    </p>
                    <p slot="sellerSku" style="font-size: 6px">
                      <span style="color: black;font-size: 3px">SellerSku:  </span>{{this.productPublishResult.data.cbPublishSkus[0].sellerSku}}
                    </p>
                  </div>
                </template>
              </a-modal>
            </div>
          </template>
          <template>
            <a-affix :offset-top="120">
              <a-card size="small" :title="$t('message.views.productPublishView.publishTemplate')"
                      style="width: 300px;height: 100px">

                <template>
                  <a-select allow-clear style="width: 100%"
                            :placeholder="$t('message.views.productPublishView.plsChooseTemplateToPublish')"
                            @change="handleTemplateChange">
                    <a-select-option v-for="i in this.searchdata" :key="i.id">
                      <a-popover :title="$t('message.views.productPublishView.templateDetail')" placement="left">
                        <template slot="content">
                          <div v-html="divHtml.get(i.id).longDescription" style="width: 1000px">
                          </div>
                          <a-divider/>
                          <div v-html="divHtml.get(i.id).shortDescription" style="width: 1000px">
                          </div>
                        </template>
                        {{ i.templateName}}
                      </a-popover>

                    </a-select-option>
                  </a-select>
                </template>
              </a-card>
            </a-affix>
          </template>
        </a-space>
        <a-form-item :label="$t('message.views.productPublishView.mainImage')" validate-status="error"
                     :help="$t('message.views.productPublishView.atLeastOneImage')">
          <div class="clearfix">
            <a-upload
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              list-type="picture-card"
              :file-list="mainFileList"
              @preview="handleMainPreview"
              :beforeUpload="beforeMainImageUpload"
              @change="handleMainImageChange"
              :remove="handleMainCancel"
              v-decorator="['main_page', { rules: [{ required: true, message: 'Please upload main images!' }] }]"
            >
              <div v-if="mainFileList.length <7">
                <a-icon type="plus"/>
                <div class="ant-upload-text">
                  {{$t('message.views.productPublishView.upload')}}
                </div>
              </div>
            </a-upload>
            <a-modal :visible="mainPreviewVisible" :footer="null" @cancel="handleMainPreviewClose">
              <img alt="example" style="width: 100%" :src="mainPreviewImage"/>
            </a-modal>
          </div>
        </a-form-item>
        <a-form-item :label="$t('message.views.productPublishView.skuImage')" validate-status="error"
                     :help="$t('message.views.productPublishView.atLeastOneImage')">
          <div class="clearfix">
            <a-upload
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              list-type="picture-card"
              :file-list="fileList"
              @preview="handlePreview"
              :beforeUpload="beforeImageUpload"
              @change="handleImageChange"
              :remove="handleCancel"
              v-decorator="['sku_page', { rules: [{ required: true, message: 'Please upload sku images!' }] }]"
            >
              <div v-if="fileList.length <7">
                <a-icon type="plus"/>
                <div class="ant-upload-text">
                  {{$t('message.views.productPublishView.upload')}}
                </div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handlePreviewClose">
              <img alt="example" style="width: 100%" :src="previewImage"/>
            </a-modal>
          </div>
        </a-form-item>

        <a-form-item :label="$t('message.views.productPublishView.publishShop')">
          <a-select style="width: 300px" :placeholder="$t('message.views.productPublishView.plsSelectThePublishShop')"
                    @change="onSiteChange"
                    v-decorator="['site', { rules: [{ required: true, message: 'Please choose your shop!' }] }]">
            <a-select-option v-for="shop in this.shopSelectValues" :key="shop.key">
              {{ shop.name }}
            </a-select-option>

          </a-select>
        </a-form-item>
        <a-form-item :label="$t('message.views.productPublishView.category')">
          <a-cascader :options="options" :showSearch="true"
                      :placeholder="$t('message.views.productPublishView.plsSelectTheCategory')"
                      @change="onCategoryChange"
                      v-decorator="['categoryId', { rules: [{ required: true, message: 'category is required!' }] }]"/>
        </a-form-item>
        <a-form-item :label="$t('message.views.productPublishView.brand')">
          <a-select
            show-search
            :value="brandValue"
            :placeholder="$t('message.views.productPublishView.inputSearchText')"
            style="width: 200px"
            :default-active-first-option="false"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="'None'"
            @search="handleBrandSearch"
            @change="handleBrandChange"
            v-decorator="['brandId', { rules: [{ required: true, message: 'brand is required!' }] }]"
          >
            <a-select-option v-for="d in brandData" :key="d.brandId">
              {{ d.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

      </div>
      <!-- 分割样式 -->
      <div :style="{ background: '#eceff3', padding: '0px', minHeight: '10px' }">
      </div>

      <div :style="{ background: '#fff', padding: '24px'}">

        <a-collapse v-model="activeKey" :bordered="false">
          <!-- 商品级别动态属性-->
          <a-collapse-panel v-for="attribute in normalMandatory " :key="attribute.name"
                            :header="attribute.label">

            <a-form-item v-if="attribute.input_type === 'richText'">
              <template
                v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <richText

                  :text="longContent"
                  @editorChange="editorLongChange"
                  :style="{width:'800px'}"
                />
              </template>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'input'">
              <a-input v-if="attribute.input_type === 'input' " style="width: 300px"
                       v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]"/>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'singleSelect'">
              <a-select style="width: 450px"
                        v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'multiSelect'">
              <a-select mode="multiple" style="width: 1500px"
                        v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'multiEnumInput'">
              <a-checkbox-group style="width: 1200px"
                                v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <a-checkbox v-for="item in attribute.options" :key="item.name" :value="item.name">
                  {{item.name}}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-item>

            <a-form-item v-if="attribute.input_type === 'text'">
              <a-textarea style="width: 500px"
                          v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]"/>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'enumInput'">
              <a-select style="width: 1200px"
                        v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'numeric'">
              <a-input-number style="width: 150px"
                              v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]"/>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'date'">
              <a-date-picker style="width: 150px"
                             v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]"/>
            </a-form-item>
          </a-collapse-panel>
          <a-collapse-panel v-for="attribute in skuMandatory " :key="attribute.name"
                            :header="attribute.label">
            <!--            {{ attribute.is_mandatory==1?'必填':'非必填'}}-->
            <!--            <a-form-item v-if="attribute.input_type === 'richText'">-->
            <!--              <template-->
            <!--                v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">-->
            <!--                <richText-->
            <!--                  :text="content"-->
            <!--                  @editorChange="editorChange"-->
            <!--                  :style="{width:'800px'}"-->
            <!--                />-->
            <!--              </template>-->
            <!--            </a-form-item>-->
            <a-form-item v-if="attribute.input_type === 'input'">
              <a-input v-if="attribute.input_type === 'input' " style="width: 300px"
                       v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]"/>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'singleSelect'">
              <a-select style="width: 450px"
                        v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'multiSelect'">
              <a-select mode="multiple" style="width: 1500px"
                        v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'multiEnumInput'">
              <a-checkbox-group style="width: 1200px"
                                v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <a-checkbox v-for="item in attribute.options" :key="item.name" :value="item.name">
                  {{item.name}}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-item>

            <a-form-item v-if="attribute.input_type === 'text'">
              <a-textarea style="width: 500px"
                          v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]"/>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'enumInput'">
              <a-select style="width: 1200px"
                        v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]">
                <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'numeric'">
              <a-input-number style="width: 150px"
                              v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]"/>
            </a-form-item>
            <a-form-item v-if="attribute.input_type === 'date'">
              <a-date-picker style="width: 150px"
                             v-decorator="[`${attribute.name}`, { rules: [{ required: true, message: 'required!' }] }]"/>
            </a-form-item>
          </a-collapse-panel>
          <a-collapse-panel v-for="attribute in normalNoMandatory" :key="attribute.name"
                            :header="attribute.label">
            <!--            {{ attribute.is_mandatory==1?'必填':'非必填'}}-->

            <template v-if="attribute.input_type === 'richText'">
              <richText
                :text="shortContent"
                @editorChange="editorShortChange"
                :style="{width:'800px'}"
              />
            </template>
            <a-input v-if="attribute.input_type === 'input' " style="width: 300px"/>
            <a-select v-if="attribute.input_type === 'singleSelect'" style="width: 450px">
              <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                {{item.name}}
              </a-select-option>
            </a-select>
            <a-select v-if="attribute.input_type === 'multiSelect'" mode="multiple" style="width: 500px">
              <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                {{item.name}}
              </a-select-option>
            </a-select>
            <a-checkbox-group v-if="attribute.input_type === 'multiEnumInput'" style="width: 200px">
              <a-checkbox v-for="item in attribute.options" :key="item.name" :value="item.name">
                {{item.name}}
              </a-checkbox>
            </a-checkbox-group>
            <a-textarea v-if="attribute.input_type === 'text'" style="width: 500px"/>
            <a-select v-if="attribute.input_type === 'enumInput'" style="width: 400px">
              <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                {{item.name}}
              </a-select-option>
            </a-select>
            <a-input-number v-if="attribute.input_type === 'numeric'" style="width: 150px"/>
            <a-date-picker v-if="attribute.input_type === 'date'" style="width: 150px"/>

          </a-collapse-panel>
          <a-collapse-panel v-for="attribute in skuNoMandatory " :key="attribute.name"
                            :header="attribute.label">
            <!--            {{ attribute.is_mandatory==1?'必填':'非必填'}}-->

            <!--            <template v-if="attribute.input_type === 'richText'">-->
            <!--              <richText-->
            <!--                :text="content"-->
            <!--                @editorChange="editorChange"-->
            <!--                :style="{width:'800px'}"-->
            <!--              />-->
            <!--            </template>-->
            <a-input v-if="attribute.input_type === 'input' " style="width: 300px"/>
            <a-select v-if="attribute.input_type === 'singleSelect'" style="width: 450px">
              <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                {{item.name}}
              </a-select-option>
            </a-select>
            <a-select v-if="attribute.input_type === 'multiSelect'" mode="multiple" style="width: 500px">
              <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                {{item.name}}
              </a-select-option>
            </a-select>
            <a-checkbox-group v-if="attribute.input_type === 'multiEnumInput'" style="width: 200px">
              <a-checkbox v-for="item in attribute.options" :key="item.name" :value="item.name">
                {{item.name}}
              </a-checkbox>
            </a-checkbox-group>
            <a-textarea v-if="attribute.input_type === 'text'" style="width: 500px"/>
            <a-select v-if="attribute.input_type === 'enumInput'" style="width: 400px">
              <a-select-option v-for="item in attribute.options" :key="item.name" :value="item.name">
                {{item.name}}
              </a-select-option>
            </a-select>
            <a-input-number v-if="attribute.input_type === 'numeric'" style="width: 150px"/>
            <a-date-picker v-if="attribute.input_type === 'date'" style="width: 150px"/>

          </a-collapse-panel>

        </a-collapse>
        <!-- 动态 sku 表单项 -->
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" html-type="submit">
            {{$t('message.views.productPublishView.submit')}}
          </a-button>
        </a-form-item>
      </div>

    </a-form>
  </a-layout-content>
</template>
<script>
  import request from '../../utils/request'
  import richText from '../../layouts/course-rich-text'

  const searchdata = []

  function getBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }

  export default {
    watch: {
      activeKey (key) {
        console.log(key)
      },
    },
    components: {richText},
    created () {
      request({
        url: '/shipper/shops',
        method: 'get'
      }).then(response => {
        var shops = response.data.data
        this.cbShipperId = shops[0].cbShipperId
        //获取到 cbShipperId 后查询模板数据
        request({
          url: '/template/search',
          method: 'post',
          data: {
            templateName: this.templateName,
            cbShipperId: this.cbShipperId,
            pageIndex: this.pagination.current,
            pageSize: this.pagination.pageSize
          }
        }).then(response => {
          this.searchdata = response.data.data
          this.searchdata.forEach(templateData => {
            this.divHtml.set(templateData.id, {
              longDescription: JSON.parse(templateData.content).longDescription,
              shortDescription: JSON.parse(templateData.content).shortDescription
            })
          })

          const pagination = {...this.pagination}
          pagination.total = parseInt(response.data.total)
          this.pagination = pagination
          this.loading = false
        })

        for (let shopIndex = 0; shopIndex < shops.length; shopIndex++) {
          if (shops[shopIndex].tenantGroup != 'AEGDCHAIN') {
            this.shopSelectValues.push({
              key: shops[shopIndex].sellerId + '|' + shops[shopIndex].tenantGroup,
              name: shops[shopIndex].shopName
            })
          }
        }
      })

    },
    data () {
      return {
        shopValue: null,
        categoryValue: null,
        searchdata,
        divHtml: new Map(),
        pagination: {
          defaultPageSize: 50,
          current: 1,
          pageSize: 50,
          total: 0,
          onChange: current => {
            this.pagination.current = current
            this.onSearch()
          }
        },
        cbShipperId: null,
        shopSellerId: null,
        shopSelectValues: [],
        headers: {
          authorization: 'authorization-text',
        },
        brandData: [],
        form: this.$form.createForm(this),

        siteChangeValue: '',
        previewVisible: false,
        previewImage: '',
        uploadFileList: [],
        uploadImageList: [],
        fileList: [],
        mainPreviewVisible: false,
        mainPreviewImage: '',
        mainFileList: [],
        mainUploadFileList: [],
        mainUploadImageList: [],
        text: `A dog is a type of domesticated animal.Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.`,
        activeKey: [],
        options: [],
        labelCol: {
          xs: {span: 8},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 15},
          sm: {span: 16},
        },
        brandValue: '',
        longContent: '',
        shortContent: '',

        skuNoMandatory: [],
        normalMandatory: [],
        normalNoMandatory: [],
        skuMandatory: [],
        draw: false,
        publishModelShow: false,
        publishModelFailedShow: false,
        productPublishResult: {
          'success': false,

          'data': {
            'itemId': '',
            'cbPublishSkus': [
              {
                'skuId': '',
                'skuCode': '',
                'sellerSku': ''
              }
            ],
            'message': ''
          },
          'failure': false
        },
        importDataModel: {
          sellerId: null,
          cbShipperId: null,
          categoryId: null
        },
        productImportApi: '/item/publish/import',
        productImagesUploadApi: '/item/images/upload/',
        selectCategoryId: null,
        importAlert: {
          visible: false,
          showMask: true
        },
      }
    },
    methods: {
      beforeUpload (file) {
        this.uploadFileList = []
        this.uploadFileList = [...this.uploadFileList, file]
        return false
      },
      handleImportChange ({fileList}) {
      },
      showModal () {
        this.draw = true
      },
      closeModel () {
        this.draw = false
        this.uploadFileList = null
      },
      closePublishModel () {
        this.publishModelShow = false
        this.publishModelFailedShow = false
        this.productPublishResult = {
          'success': false,

          'data': {
            'itemId': '',
            'cbPublishSkus': [
              {
                'skuId': '',
                'skuCode': '',
                'sellerSku': ''
              }
            ],
            'message': ''
          },
          'failure': false
        }
      },
      handlePublishModelOk (e) {
        this.publishModelShow = false
        this.publishModelFailedShow = false
        this.productPublishResult = {
          'success': false,

          'data': {
            'itemId': '',
            'cbPublishSkus': [
              {
                'skuId': '',
                'skuCode': '',
                'sellerSku': ''
              }
            ],
            'message': ''
          },
          'failure': false
        }
      },
      handleOk (e) {
        const formData = new FormData()
        if (this.importDataModel.sellerId == null) {
          this.$message.error('请选择店铺信息')
          return
        }
        if (this.importDataModel.categoryId == null) {
          this.$message.error('请选择类目信息')
          return
        }
        if (this.uploadFileList == null || this.uploadFileList.length === 0) {
          this.$message.error('请选择需要上传的文件')
          return
        }
        this.uploadFileList.forEach(file => {
          formData.append('file', file)
        })

        this.$refs.importAlert.showImportAlertMask()
        request({
          headers: {
            cbShipperId: this.cbShipperId,
            sellerId: this.importDataModel.sellerId,
            taskType: 1013,
            categoryId: this.selectCategoryId
          },
          url: this.productImportApi + '?sellerId=' + this.importDataModel.sellerId + '&taskType=1013&site=' + this.siteChangeValue + '&categoryId=' + this.selectCategoryId,
          method: 'post',
          processData: false,
          data: formData
        }).then(response => {
          if (response.data.success) {
            this.importAlert.visible = false
            var taskId = response.data.model

            this.$refs.importAlert.showImportWindow(taskId)
          } else {
            this.$message.error('file upload failed.`)')
          }
          this.closeModel()

        })
      },
      handleSubmit (e) {
        e.preventDefault()

        this.form.validateFields((err, values) => {

          if (!err) {

            var sellerId = this.shopSellerId
            var site = this.siteChangeValue
            var brandId
            var categoryId
            var skuImages = []
            var mainImages = []

            var normalMandatory = []
            var normalNoMandatory = []
            var skuMandatory = []
            var skuNoMandatory = []

            for (var key in values) {
              if (key === 'categoryId') {
                var strings = values[key].toString().split(',')
                var length = strings.length
                categoryId = strings[length - 1]
              } else if (key === 'brandId') {
                brandId = values[key]
                normalMandatory.push({
                  key: 'brand',
                  value: brandId
                })
              } else if (key === 'main_page') {
                this.mainFileList.forEach((v, i) => {
                  if (v.url != '' && v.url != null) {
                    mainImages.push(v.url)
                  }
                })
                console.log('mainImages :' + JSON.stringify(mainImages))
                console.log('mainImages this.mainUploadImageList: ' + JSON.stringify(this.mainUploadImageList))
                console.log('mainImages this.mainFileList: ' + JSON.stringify(this.mainFileList))
              } else if (key === 'sku_page') {
                this.fileList.forEach((v, i) => {
                  if (v.url != '' && v.url != null) {
                    skuImages.push(v.url)
                  }
                })
                console.log('skuImages :' + JSON.stringify(skuImages))
                console.log('skuImages this.uploadImageList: ' + JSON.stringify(this.uploadImageList))
                console.log('skuImages this.fileList: ' + JSON.stringify(this.fileList))
              } else {
                normalMandatory.push({
                  key: 'description',
                  value: this.longContent
                })
                this.normalMandatory.forEach(normal => {
                  if (normal.name === key) {
                    normalMandatory.push({
                      key: key,
                      value: values[key]
                    })
                  }
                })
                this.skuMandatory.forEach(normal => {
                  if (normal.name === key) {
                    skuMandatory.push({
                      key: key,
                      value: values[key]
                    })
                  }
                })
                normalNoMandatory.push({
                  key: 'short_description',
                  value: this.shortContent
                })
                this.normalNoMandatory.forEach(normal => {
                  if (normal.name === key) {
                    normalNoMandatory.push({
                      key: key,
                      value: values[key]
                    })
                  }
                })

                this.skuNoMandatory.forEach(normal => {
                  if (normal.name === key) {
                    skuNoMandatory.push({
                      key: key,
                      value: values[key]
                    })
                  }
                })
              }

            }

            request({
              url: '/item/publish',
              method: 'post',
              data: {
                site: site,
                skuImages: skuImages,
                mainImages: mainImages,
                brandId: brandId,
                categoryId: categoryId,
                sellerId: sellerId,
                skuNoMandatory: JSON.stringify(skuNoMandatory),
                skuMandatory: JSON.stringify(skuMandatory),
                normalNoMandatory: JSON.stringify(normalNoMandatory),
                normalMandatory: JSON.stringify(normalMandatory)
              }
            }).then(response => {
              var results = response
              console.log('publish result: ' + JSON.stringify(results))
              this.productPublishResult = results.data
              if (results.data.success == true) {
                //获取 results.data.data :{商品详情}
                console.log('productPublishResult : ' + JSON.stringify(this.productPublishResult))

                this.successAlert('Success')
                this.publishModelShow = true
              } else {
                this.productPublishResult.data = {
                  'itemId': '',
                  'cbPublishSkus': [
                    {
                      'skuId': '',
                      'skuCode': '',
                      'sellerSku': ''
                    }
                  ],
                  'message': ''
                }

                this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
                this.publishModelFailedShow = true
                e.preventDefault(results.errorMsg)
              }
            })
          }
        })

      },
      handleBrandSearch (value) {

        this.brandData = []
        var queryStr = '?name=' + value
        request({
          url: '/brand/search/' + this.siteChangeValue + queryStr,
          method: 'get',
        }).then(response => {
          if (response.data.success == true) {
            var results = response.data.data
            results.forEach(n => {
              this.brandData.push({
                brandId: n.brandId,
                name: n.name
              })
            })
          } else {
            this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
          }
        })
      },
      handleBrandChange (value) {
        this.brandValue = value
      },
      onCategoryChange (value) {
        var strings = value.toString().split(',')
        var length = strings.length
        var categoryId = strings[length - 1]
        this.selectCategoryId = categoryId
        this.importDataModel.categoryId = categoryId
        request({
          url: '/category/attribute/divide/LAZADA/' + this.siteChangeValue + '/' + categoryId,
          method: 'get'
        }).then(response => {
          var results = response.data.data
          if (response.data.success) {
            this.skuNoMandatory = results.skuNoMandatory
            console.log('skuNoMandatory: ' + JSON.stringify(this.skuNoMandatory))
            this.normalMandatory = results.normalMandatory
            console.log('normalMandatory: ' + JSON.stringify(this.normalMandatory))
            this.normalNoMandatory = results.normalNoMandatory
            console.log('normalNoMandatory: ' + JSON.stringify(this.normalNoMandatory))
            this.skuMandatory = results.skuMandatory
            console.log('skuMandatory: ' + JSON.stringify(this.skuMandatory))
            this.activeKey = []
            this.normalMandatory.forEach(attribute => {
              this.activeKey.push(attribute.name)
            })
            this.skuMandatory.forEach(attribute => {
              this.activeKey.push(attribute.name)
            })
          } else {
            this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
          }
        })
      },
      onBatchSellerChange (value) {

        var splitSeller = value.toString().split('|')
        this.shopSellerId = splitSeller[0]
        this.siteChangeValue = splitSeller[1].toString()
        this.importDataModel.sellerId = this.shopSellerId
        this.importDataModel.cbShipperId = this.cbShipperId
        request({
          url: '/category/tree/LAZADA/' + this.siteChangeValue,
          method: 'get'
        }).then(response => {
          if (response.data.success) {
            this.options = response.data.data
          } else {
            this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
          }
        })
      },
      onSiteChange (value) {
        var splitSeller = value.toString().split('|')
        this.shopSellerId = splitSeller[0]
        this.siteChangeValue = splitSeller[1].toString()
        request({
          url: '/category/tree/LAZADA/' + this.siteChangeValue,
          method: 'get'
        }).then(response => {
          if (response.data.success) {
            this.options = response.data.data
          } else {
            this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
          }
        })
      },
      handleMainPreviewClose () {
        this.mainPreviewVisible = false
      },
      handlePreviewClose () {
        this.previewVisible = false
      },
      handleMainCancel (file) {
        var index
        var i = 0
        this.mainFileList.forEach(n => {
          if (this.mainFileList[i].name == file.name) {
            index = i
          }
          i++
        })
        this.mainFileList.splice(index, 1)
        return true
        console.log('handleMainCancel this.mainUploadImageList: ' + JSON.stringify(this.mainUploadImageList))
        console.log('handleMainCancel this.mainFileList: ' + JSON.stringify(this.mainFileList))
      },
      handleCancel (file) {
        var index
        var i = 0
        this.fileList.forEach(n => {
          if (this.fileList[i].name == file.name) {
            index = i
          }
          i++
        })
        this.fileList.splice(index, 1)
        return true
        console.log('handleCancel this.uploadImageList: ' + JSON.stringify(this.uploadImageList))
        console.log('handleCancel this.fileList: ' + JSON.stringify(this.fileList))
      },
      beforeImageUpload (file) {
        this.uploadImageList = []
        this.uploadImageList = [...this.uploadImageList, file]
        console.log('beforeImageUpload this.uploadImageList: ' + JSON.stringify(this.uploadImageList))
        console.log('beforeImageUpload this.fileList: ' + JSON.stringify(this.fileList))
        return false
      },
      beforeMainImageUpload (file) {
        this.mainUploadImageList = []
        this.mainUploadImageList = [...this.mainUploadImageList, file]
        console.log('beforeMainImageUpload this.mainUploadImageList: ' + JSON.stringify(this.mainUploadImageList))
        console.log('beforeMainImageUpload this.mainFileList: ' + JSON.stringify(this.mainFileList))
        return false
      },
      async handlePreview (file) {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj)
        }
        this.previewImage = file.url || file.preview
        this.previewVisible = true
      },
      async handleMainPreview (file) {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj)
        }
        this.mainPreviewImage = file.url || file.preview
        this.mainPreviewVisible = true
      },
      handleMainImageChange (file) {
        const formData = new FormData()
        var cbShipperId = this.cbShipperId
        var existUids = []
        this.mainFileList.forEach(n => {
          existUids.push(n.uid)
        })

        if (existUids.includes(file.file.uid)) {
          return
        } else {
          this.mainUploadImageList.forEach(file2 => {

              formData.append('file', file2)
              request({
                url: this.productImagesUploadApi + cbShipperId,
                method: 'post',
                processData: false,
                data: formData
              }).then(response => {
                if (response.data.success) {
                  var result = response.data.data
                  result.uid = file2.uid
                  this.mainFileList.push(result)
                  console.log('handleMainImageChange this.mainUploadImageList: ' + JSON.stringify(this.mainUploadImageList))
                  console.log('handleMainImageChange this.mainFileList: ' + JSON.stringify(this.mainFileList))
                } else {
                  this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
                }
              })
            }
          )
        }
      },
      handleImageChange (file) {

        const formData = new FormData()
        var cbShipperId = this.cbShipperId
        var existUids = []
        this.fileList.forEach(n => {
          existUids.push(n.uid)
        })

        if (existUids.includes(file.file.uid)) {
          return
        } else {
          this.uploadImageList.forEach(file2 => {

              formData.append('file', file2)
              request({
                url: this.productImagesUploadApi + cbShipperId,
                method: 'post',
                processData: false,
                data: formData
              }).then(response => {
                if (response.data.success) {
                  var result = response.data.data
                  result.uid = file2.uid
                  this.fileList.push(result)
                  console.log('handleImageChange this.uploadImageList: ' + JSON.stringify(this.uploadImageList))
                  console.log('handleImageChange this.fileList: ' + JSON.stringify(this.fileList))
                } else {
                  this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
                }
              })
            }
          )
        }
      },
      editorLongChange: function (html) {
        this.longContent = html
      },
      editorShortChange: function (html) {
        this.shortContent = html
      },
      handleTemplateChange (value) {
        this.longContent = this.divHtml.get(value).longDescription
        this.shortContent = this.divHtml.get(value).shortDescription
        console.log(`selected ${value}`)
      },
      successAlert (msg) {
        this.$message.success(msg)
      },
      errorAlert (msg) {
        this.$message.error(msg)
      },
      warningAlert (msg) {
        this.$message.warning(msg)
      },
    }
  }
</script>
<style>
  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/views/Item/ProductPublishView.vue